import type { LayoutSpec, PanelType } from '../../../types/LayoutConfig';

export const SINGLETON_PANEL_TYPES: ReadonlySet<PanelType> = new Set(['dealerSpaceParameters']);

export function isSingletonPanelType(panelType: string | undefined): panelType is PanelType {
  return SINGLETON_PANEL_TYPES.has(panelType as PanelType);
}

export function selectedLayoutHasPanelType(selectedLayout: LayoutSpec | undefined, panelType: PanelType) {
  return Object.values(selectedLayout?.dockViewLayout.panels ?? {}).some(
    panel => panel.params?.type === panelType || panel.contentComponent === panelType
  );
}

export function dockviewHasPanelType(
  panels: { api: { component?: string }; params?: { type?: string } }[],
  panelType: PanelType
) {
  return panels.some(panel => panel.params?.type === panelType || panel.api.component === panelType);
}

export function canAddPanelTypeToDockview(
  panels: { api: { component?: string }; params?: { type?: string } }[],
  panelType: PanelType
) {
  return !isSingletonPanelType(panelType) || !dockviewHasPanelType(panels, panelType);
}
